export default __webpack_public_path__ + "static/media/60705.71b94658.jpg";